import React, { Component } from 'react';
import { Redirect } from 'react-router'
import '../css/materialize.css'
import '../css/dev.css'
import '../css/responsive.css'
import './home.css'
import Header from '../header/newheader'
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import cachios from 'cachios'
import Footer from '../footer/newfooter';
// import HomeArticle from './homearticle'
import search from '../assets/search.png'
import VideoComponent from './video'
import grey from '../assets/grey.jpg'
import { List } from 'react-content-loader'
import HeaderBkp from '../header/headerbkp';


class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            redirect: false,
            tab: 1,

            keyword: '',
            img_source: '',
            searchfilter: '',
            search_menu_opt: localStorage.getItem('lang')?true:false

        }

    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.search()
        }
    }
    search() {
        if(this.state.searchfilter)
            this.props.history.push('/search/'+this.state.keyword+'/'+this.state.searchfilter)
        else
            this.props.history.push('/search/'+this.state.keyword)
    }
    componentWillMount() {
        this.setState({
            searchfilter:''
        })
        //News
        cachios.get(BASE + 'jsonapi/node/news?include=field_source&page[limit]=5&sort=-changed', {
            ttl: 300 /* seconds */,
        })

            .then((data) => {
                let i, j;
                let logoarray = []
                console.log(data.data.included)
                this.setState({
                    articles: data.data.data,
                })
                for (i = 0; i < data.data.data.length; i++) {

                    if (data.data.data[i].relationships.field_source.data != null) {
                        for (j = 0; j < data.data.included.length; j++) {
                            if (data.data.data[i].relationships.field_source.data.id === data.data.included[j].id) {
                                logoarray.push(BASE + data.data.included[j].attributes.uri.url)
                            }
                        }
                    }
                    else {
                        logoarray.push(grey);

                    }
                    console.log(logoarray)
                    this.setState({
                        img_source: logoarray
                    })

                }

            })
            .catch((err) => {
                console.log('not found')
            })


        //   booklist
        cachios.get(BASE + 'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]=Books&page[limit]=5&filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&include=field_image&sort=-created&page[limit]=4', {
            ttl: 300 /* seconds */,
        })
        .then((data) => {
                this.setState({
                    books: data.data.data,
                    bookimg: data.data.included,
                })
            })

            .catch((err) => {
                console.log('not found')
            })


        //Events



    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    checkopen(data) {
        this.setState({
            isVideoModalOpen: data
        })
    }
    langSelected(e) {
        console.log(e)
        let tmp;
        if (e == "ara") {
            tmp = true;
        }
        else
            tmp = false;
        console.log(tmp)
        this.setState({
            search_menu_opt: undefined
        })
        this.setState({
            search_menu_opt: tmp
        })
    }

    render() {
        if (this.state.redirect) {
            if(this.state.searchfilter)
            return <Redirect to={'/search/'+this.state.keyword+'/'+this.state.searchfilter} />;

            else
                return <Redirect to={'/search/'+this.state.keyword} />;

          }
        else

        return (
            <div className='contact_rea homepage page-events' style={{ height: this.state.isVideoModalOpen == true ? '100vh' : '', overflow: this.state.isVideoModalOpen == true ? 'hidden' : '' }}>
                <HeaderBkp history={this.props} langSelected={(e) => this.langSelected(e)} />
                <div className="col s12 m12 l12 searchparent">
                    <div className="searchdiv">
                        {this.state.width > 760 ? <div className="searchtabs">
                            <div onMouseEnter onClick={() => this.setState({ searchfilter:'programe:11' })} style={{ backgroundColor: this.state.searchfilter === 'programe:11' ? '#213792' : '', color: this.state.searchfilter === 'programe:11' ? 'white' : '' }}> {this.state.search_menu_opt == true ? "التمويل الإسلامي والاقتصاد" : "Islamic Finance & Economy"}</div>
                            <div onClick={() => this.setState({ searchfilter: 'programe:12' })} style={{ backgroundColor: this.state.searchfilter === 'programe:12' ? '#213792' : '', color: this.state.searchfilter === 'programe:12' ? 'white' : '' }}> {this.state.search_menu_opt == true ? "الدراسات الإسلامية" : "Islamic Studies"}</div>
                            <div onClick={() => this.setState({ searchfilter: 'programe:13' })} style={{ backgroundColor: this.state.searchfilter === 'programe:13' ? '#213792' : '', color: this.state.searchfilter === 'programe:13' ? 'white' : '' }}>{this.state.search_menu_opt == true ? "الإسلام والشؤون الدولية" : "Islam & Global Affairs"} </div>
                            <div onClick={() => this.setState({ searchfilter: 'programe:14' })} style={{ backgroundColor: this.state.searchfilter ==='programe:14' ? '#213792' : '', color: this.state.searchfilter ==='programe:14' ? 'white' : '' }}> {this.state.search_menu_opt == true ? "الفن والعمارة الإسلامية والعمران" : "Islamic Art, Architecture & Urbanism"}</div>
                        </div>
                            :
                            <div>
                                <select name="searchfilter" onChange={e => this.handleChange(e)} value={this.state.lang2}>
                                    <option value="11" disabled selected>Filter By</option>
                                    <option value="11">{this.state.search_menu_opt == true ? "التمويل الإسلامي والاقتصاد" : "Islamic Finance & Eco"} </option>
                                    <option value="12">{this.state.search_menu_opt == true ? "الدراسات الإسلامية" : "Islamic Studies"}</option>
                                    <option value="13">{this.state.search_menu_opt == true ? "الإسلام والشؤون الدولية" : "Islam & Global Affairs"} </option>
                                    <option value="14">{this.state.search_menu_opt == true ? "الفن والعمارة الإسلامية والعمران" : "Islamic Art, Architecture & Urbanism"}</option>
                                </select>
                            </div>}

                        <div className='homesearch'>
                            <div>
                                <input placeholder="Search" type="text" id="edit-keys" name="keyword" value={this.state.keyword} size="40" minLength="3" maxLength="50" className="form-text" onChange={e => { this.handleChange(e) }} onKeyPress={(e) => this._handleKeyPress(e)} />



                            </div>
                            <img onClick={() => this.search()} src={search} alt='search' />
                        </div>
                    </div>
                    <div className='linkbox'>
                        <Link to='/research_cluster' className='firstlink'>{this.state.search_menu_opt == true ? "مجموعات البحوث" : "CIS Research Clusters"}</Link>

                        <Link to='/cis_publication' className='firstlink'>{this.state.search_menu_opt == true ? "كتب" : "CIS Faculty publications"}</Link>
                    </div>

                </div>


                {/* <div className='homesearch'>
        <div>
            <img src={search} alt='search'/>
            <input placeholder="Search" type="text" id="edit-keys" name="keyword"  value={this.state.keyword} size="40" minLength="3" maxLength="25" className="form-text" onChange={e => {this.handleChange(e);this.search(e)}}  onKeyPress={(e) => this._handleKeyPress(e)}/>
            <select  name="lang2"  onChange={e => this.handleChange(e)} value={this.state.lang2}>
                <option value="" disabled selected>filter by</option>
                <option value="ar">Arabic</option>
                <option value="en">English</option>
            </select>
           

        </div>
        <button>search</button>
        </div> */}




                <div className="listing">
                    <div className="main-content aboutcis">
                        <div className="container">
                            <div className="row ">
                                {/* icons */}
                              

                                {/* events */}
                                <div className="col s12 m12 l12 eveviddiv">

                                    {/* Videosectn */}
                                    <div className="col s12 m6 l6 homeviddiv">
                                        <div className="container col s12 m12 l12 ">

                                            <VideoComponent checkopen={(data) => this.checkopen(data)} />
                                        </div>
                                    </div>
                                </div>

                                {/* Books */}
                                <div className="col s12 m12 l12 homebooks">
                                    <div className="container col s12 m12 l12">
                                        <body className="html not-front not-logged-in no-sidebars page-books">




                                            <div className="page-title">
                                                <div className="title-wrapper">
                                                    <div className="container">
                                                        <h1 className="page-header"><Link to='/cis_publication'>{this.state.search_menu_opt === true ?'كتب':'CIS Publications'} </Link></h1>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="main-content homebook">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="region region-content">
                                                            <div id="block-system-main" className="block block-system">


                                                                <div className="content">
                                                                    <div className="view view-wiki view-id-wiki view-display-id-page_1 view-dom-id-068a6a9a28a40cd3a4b7c136ad70974f">



                                                                        <div className="view-content">
                                                                            {this.state.books && this.state.bookimg ? this.state.books.map((book, index) => {
                                                                                return (

                                                                                    <div className="col s6 m3 l3 ">
                                                                                        <Link to={{ pathname:  '/book_desc/' + `${book.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${book.attributes.drupal_internal__nid}`, state: {  dat_arr: book.attributes  } }}>
                                                                                            <img typeof="foaf:Image" src={BASE + this.state.bookimg[index].attributes.uri.url} alt="" />
                                                                                        </Link>
                                                                                        <div className="box-title">

                                                                                            <Link to={{ pathname: '/book_desc/' + `${book.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${book.attributes.drupal_internal__nid}`, state: { dat_arr: book.attributes  } }}>
                                                                                                {book.attributes.title.substring(0, 55)}{book.attributes.title.length > 55 ? '....' : ''}
                                                                                            </Link></div>
                                                                                        {/* <div className="box-sub">{book.attributes.field_author}</div> */}

                                                                                    </div>
                                                                                )
                                                                            }
                                                                            ) : <List />}



                                                                        </div>






                                                                    </div>  </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </body>
                                    </div>



                                </div>


                                {/* BOOKS */}
                                <div id="wrapper-5" class="section">
                                    <div class="container">
                                        <div class="region region-wrapper-five">
                                            <div id="block-block-1" class="block block-block">


                                                <div class="content">
                                                    <p>Subscribe to our monthly newsletter</p>
                                                    <p><a class="waves-effect waves-light btn-large" href="http://eepurl.com/buCqkr" target="_blank">Subscribe</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>


                        </div>
                    </div>


                </div>
                {this.state.articles?this.state.articles.length!=0 ?<div className="row homearticle">

                    {/* newslist */}
                    <div className="col s12 m6 l6 ">
                        <div className="page-title">
                            <div className="title-wrapper">
                                <div className="container">
                                    <h1 className="page-header"><Link to='/news'>{this.state.search_menu_opt === true? 'أخبار':"News"}</Link></h1>
                                </div>
                            </div>
                        </div>
                        <div className="main-content listing">
                            <div className="container ">
                                <div className="row">
                                    <div className="region region-content">
                                        <div className="listings">

                                            {this.state.articles ? this.state.articles.map((article, index) => {
                                                return (
                                                    <div className="title">
                                                        <span className="field-content">
                                                            <Link to={{ pathname: '/news_desc/'+`${article.attributes.title.replace(/ /g,"-").toLowerCase()}`+'?nid=' + `${article.attributes.drupal_internal__nid}`, state: { search: false, link: article, source_img: this.state.img_source[index] ? this.state.img_source[index] : '' } }}>{article.attributes.title}</Link>
                                                        </span>
                                                    </div>
                                                )
                                            }
                                            ) : <List />

                                            }

                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* main news img */}
                    {this.state.img_source && this.state.width > 760 ?
                        <div className="col s12 m6 l6 container newsimgsec">
                            <div className="page-title">
                                <div className="title-wrapper">
                                    <div className="container">
                                        <h1 className="page-header"><Link to='/news'></Link></h1>
                                    </div>
                                </div>
                            </div>
                            <Link to={{ pathname: '/news_desc/'+`${this.state.articles[0].attributes.title.replace(/ /g,"-").toLowerCase()}`+'?nid=' + `${this.state.articles[0].attributes.drupal_internal__nid}`, state: { search: false, link: this.state.articles[0], source_img: this.state.img_source[0] ? this.state.img_source[0] : '' } }}>
                                <div className="newsimgdiv">
                                    <img src={this.state.img_source[0]} alt='news' />

                                    <div className="newsimgtext">{this.state.articles[0].attributes.title}</div>
                                </div>
                            </Link>
                        </div> : ''}

                </div>:'':''}
                <Footer />
            </div>
        )


    }

}

export default HomePage;
